module.exports = __webpack_public_path__ + "2020celebration/img/accident-l.1a79163c.png";